/**
 * BLOCK: FAQ - Child - Save Block
 */

import classnames from 'classnames';
import renderSVG from '@Controls/render-icon';
import { RichText } from '@wordpress/block-editor';
import { Fragment } from '@wordpress/element';


export default function save(props) {
	const { className } = props;
	const {
		/* eslint-disable */
		block_id,
		/* eslint-enable */
		question,
		answer,
		icon,
		iconActive,
		layout,
		headingTag,
	} = props.attributes;

	const faqRenderIcon = () => {
		return (
			<Fragment>
				<span className="wpsp-icon wpsp-faq-icon-wrap">
					{renderSVG(icon)}
				</span>
				<span className="wpsp-icon-active wpsp-faq-icon-wrap">
					{renderSVG(iconActive)}
				</span>
			</Fragment>
		);
	};
	const faqRenderAccordion = () => {
		return (
			<div className="wpsp-faq-child__wrapper">
				<div className="wpsp-faq-item" role="tab" tabIndex="0">
					<div className="wpsp-faq-questions-button wpsp-faq-questions">
						{'accordion' === layout && faqRenderIcon()}
						<RichText.Content
							tagName={headingTag}
							value={question}
							className="wpsp-question"
						/>
					</div>
					<div className="wpsp-faq-content">
						<span>
							<RichText.Content tagName="p" value={answer} />
						</span>
					</div>
				</div>
			</div>
		);
	};
	return (
		<div
			className={classnames(
				className,
				'wpsp-faq-child__outer-wrap',
				/* eslint-disable */
				`wpsp-block-${block_id}`
				/* eslint-enable */
			)}
		>
			{faqRenderAccordion()}
		</div>
	);
}
